import { TestCarInterface } from '@modules/card/interfaces/test-car.interface';
import { TestCarModel } from '@modules/card/models/test-car.model';
import { RibbonSliderFilterInterface } from '@modules/slider/interfaces/ribbon-slider.interface';

import { SectionType } from '../enums/section-type.enum';

import { Section } from './section.model';

export interface TestCarSectionInterface {
  id: string;
  headline?: string;
  anchor?: string;
  teasers: TestCarInterface[];
}

export class TestCarSectionModel implements Section {
  public id: string;
  public type = SectionType.TEST_CAR;
  public teasers: TestCarModel[];
  public headline?: string;
  public customHeadline = true;
  public anchor?: string;
  public filters: RibbonSliderFilterInterface[] = [{ label: 'ALL', value: 'ALL', active: true }];

  constructor(data: TestCarSectionInterface) {
    this.id = data.id;
    this.headline = data.headline;
    this.anchor = data.anchor;
    this.teasers = data.teasers.map((item) => new TestCarModel(item));
    const filters: any = {};
    this.teasers.forEach((item) => {
      if (!filters[item.filter.value] && item.filter.value !== '') {
        this.filters.push(item.filter);
      }
      filters[item.filter.value] = true;
    });
    if (this.filters.length < 2) {
      this.filters = [];
    }
  }
}
